// packages
import { line } from 'd3-shape';
import { max, zip, extent } from 'd3-array';
import { select } from 'd3-selection';
import { scaleUtc, scaleLinear } from 'd3-scale';

// local
import { createBase } from '../../utils/d3-base';
import { movingAverage } from '../../utils/moving-average';

const mobileWidth = 400;

export function boot(data, includeAverage = true, id = 'new-cases-chart') {
  const container = select(`#${id}`);
  data.forEach((d) => {
    if (d.new_reported_and_probable_cases < 0) {
      d.new_reported_and_probable_cases = 0;
    }
  });

  const trimmedData = data.filter((value, index, arr) => {
    return index >= data.length - 49;
  });

  const averageLine = movingAverage(
    trimmedData.map((d) => d.new_reported_and_probable_cases),
    7
  );

  const preppedData = zip(
    trimmedData.map((d) => d.date),
    averageLine
  ).filter((d) => d[1]);

  render();

  function render() {
    // empty the container on render every time
    container.html('');
    //height: 30, bottom: 0, top: 2
    const height = 24;
    const { g, x, y, width, xAxis, yAxis, drawAxis } = createBase({
      container,
      height: height,
      x: scaleUtc(),
      y: scaleLinear(),
      margin: { left: 5, bottom: 5, top: 5, right: 5 },
      title: 'New confirmed cases by day',
    });

    const ltMobileWidth = width < mobileWidth;

    // set up our x scale
    const xRange = preppedData.map((d) => d[0]);
    x.domain(extent(xRange));

    // set up our y scale
    const yValues = preppedData.map((d) => d[1]);
    const yMax = max(yValues);
    y.domain([0, yMax]).nice();

    const generateLine = line()
      .x((d) => x(d[0]))
      .y((d) => y(d[1]));

    const markerBoxWidth = 3;
    const markerBoxHeight = 3.5;
    const refX = 0;
    const refY = markerBoxHeight / 2;
    const markerWidth = markerBoxWidth / 2;
    const markerHeight = markerBoxHeight / 2;
    const arrowPoints = [
      [0, 0],
      [0, markerBoxHeight],
      [markerBoxWidth, markerBoxHeight / 2],
    ];

    g.append('defs')
      .append('marker')
      .attr('id', 'dot')
      .attr('width', 6)
      .attr('height', 6)
      .attr('viewBox', [0, 0, 6, 6])
      .attr('refX', 3)
      .attr('refY', 3)
      .attr('markerWidth', 6)
      .attr('markerHeight', 6)
      .append('circle')
      .attr('cx', 3)
      .attr('cy', 3)
      .attr('r', 1.7)
      .style('fill', '#3894b7');

    g.append('g')
      .attr('class', 'average-line')
      .append('path')
      .datum(preppedData)
      .attr('fill', 'none')
      .attr('stroke', '#3894b7')
      .attr('stroke-width', '2')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-linecap', 'round')
      .attr('role', 'graphics-symbol')
      .attr('d', generateLine)
      .attr('marker-end', 'url(#dot)');
  }

  return render;
}
